module.exports = __webpack_public_path__ + "static/media/logo_light_malarso.12a6aa09.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/logo_light_malarso.png
// module id = 1602
// module chunks = 0